import { createBridgeChannel } from '@robinpowered/dashboard-apps-common';
var submitSuccess = createBridgeChannel('dashboard:event-composer:submit-success');
var submitError = createBridgeChannel('dashboard:event-composer:submit-error');
export var emitEventSubmitSuccess = submitSuccess.emit;
export var onEventSubmitSuccess = submitSuccess.subscribe;
export var useEmitEventSubmitSuccess = submitSuccess.useEmit;
export var useEventSubmitSuccess = submitSuccess.useSubscribe;
export var emitEventSubmitError = submitError.emit;
export var onEventSubmitError = submitError.subscribe;
export var useEmitEventSubmitError = submitError.useEmit;
export var useEventSubmitError = submitError.useSubscribe;
